module.exports = __webpack_public_path__ + "static/media/rdh.e9c1eebf.png";